import './subscribe-form.scss';
import {
	sha256,
	onVisible,
	setInputBorderRed,
} from '../../assets/js/modules/common';
import {
	sendFormSubmitted,
	sendFormViewed,
} from '../../assets/js/tracking/eventsTracking';
import { closeModal } from '../modal/modal';
import { setUserSubscribedCookie } from '../../assets/js/modules/authentication';
import {
	isValidEmailOnInput,
	isInputEmpty,
} from '../../assets/js/modules/validation';
import { handleUserFormSubmission } from '../user-form/user-form';
(($) => {
	const closeButton = $('#close-subscribe-modal');
	closeButton.on('click', () => {
		closeModal('subscribe-modal');
	});

	const subscribeButton = $('#subscribe-form-submit');
	subscribeButton.on('click', () => {
		if (isValidInput()) {
			sendCoreIdentifyEvent();
			setTimeout(sendFormSubmittedEvent, 3000);
			setTimeout(() => handleUserFormSubmission(getEmail()), 3000);
			updateIterableList(getEmail());
			closeModal('subscribe-modal');
			setUserSubscribedCookie();
		} else {
			showError();
		}
	});

	const modal = document.getElementById('user-capture-subscribe');
	onVisible(modal, () => {
		sendFormViewedEvent();
	});
})(jQuery);

const getEmail = () => {
	return $('#subscribe-form-email-input').val();
};
const sendCoreIdentifyEvent = () => {
	const email = $('#subscribe-form-email-input').val();
	const name = $('#subscribe-form-name-input').val();

	const traits = {
		email,
		firstName: name,
	};
	sha256(email).then(function (hashedEmail) {
		tagular('beam', {
			'@type': 'core.Identify.v1',
			traits,
			userId: hashedEmail,
		});
	});
};
const eventPayload = {
	formType: 'email',
	formName: 'subscribe',
	formId: 'subscribe-form',
	captureType: 'Custom Form',
	capturePlacement: 'Modal',
	valueProp: 'Newsletter',
};
const sendFormSubmittedEvent = () => {
	sendFormSubmitted(eventPayload);
};

const sendFormViewedEvent = () => {
	sendFormViewed(eventPayload);
};

const isValidInput = () => {
	return (
		isValidEmailOnInput('subscribe-form-email-input') ||
		!isInputEmpty('subscribe-form-name-input')
	);
};

const showError = () => {
	if (!isValidEmailOnInput('subscribe-form-email-input')) {
		setInputBorderRed('subscribe-form-email-input');
	}
	if (isInputEmpty('subscribe-form-name-input')) {
		setInputBorderRed('subscribe-form-name-input');
	}
};

const updateIterableList = (email) => {
	fetch(
		window.location.origin + '/wp-json/email/v1/users/default_subscription',
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				email
			}),
		},
	)
		.then((response) => {
			if (!response.ok) {
				throw new Error('Network response was not ok');
			}
			return response;
		}).then(() => {
			console.log('successfully updated iterable list');
		})
		.catch(() => {
			console.log('failed while updating iterable list');
		});
};
